"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _numericFormatters = require("@figure/frontlib-util/lib/numeric-formatters");

var _Constant = require("../Constant");

var _Flex = require("../Layout/Flex");

var _Label = _interopRequireDefault(require("../Form/Label"));

var _util = require("../Util/util");

var _thumb = _interopRequireDefault(require("./thumb.svg"));

var _theme, _theme2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n  font-weight: 500;\n  font-size: 1.3rem;\n  letter-spacing: 0.023em;\n  margin-bottom: 5px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  justify-content: space-between;\n\n  p: last-of-type {\n    text-align: right;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: 1px solid transparent;\n  height: 3.2rem;\n  left: calc(", "% - ", "px);\n  position: absolute;\n  top: -1.3rem;\n  width: 4.8rem;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  border-radius: 30px;\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: ", "%;\n\n  /* border required for Windows high contrast mode */\n  @media (forced-colors: active) {\n    border: 2px solid Highlight;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  border-radius: 30px;\n  height: 0.4rem;\n  position: relative;\n\n  @media (forced-colors: active) {\n    /* High contrast mode removes background colors. The transparent border is added so the slider track remains visible. */\n    border: 1px solid transparent;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  -webkit-appearance: none;\n  background-color: transparent; /* Defaults to white in Chrome */\n  border: 0;\n  color: transparent;\n  height: 0.4rem;\n  left: 0;\n  margin: 0; /* Align NativeSlider and CustomTrack */\n  overflow: visible;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 1; /* HTML slider should be above the visible \"slider\" */\n\n  &::-moz-range-track {\n    background-color: transparent;\n    border: 0;\n    color: transparent;\n    height: 0.4rem;\n    margin: 0;\n    overflow: visible;\n    width: 100%;\n  }\n\n  &::-ms-track {\n    background-color: transparent;\n    border: 0;\n    color: transparent;\n    height: 0.4rem;\n    margin: 0;\n    overflow: visible;\n    width: 100%;\n  }\n\n  /* IE10+ and Edge - eliminates default fills before and after thumb */\n  &::-ms-fill-lower {\n    background-color: transparent;\n    border: 0;\n  }\n\n  &::-ms-fill-upper {\n    background-color: transparent;\n    border: 0;\n  }\n\n  &::-ms-tooltip {\n    display: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-moz-focus-outer {\n    border: 0; /* Removes the default focus style on FF */\n  }\n\n  /* The custom thumb visually has focus when the HTML input has focus */\n  &[data-focus-visible-added]:focus ~ .custom-track {\n    .custom-thumb {\n      ", "\n    }\n  }\n\n  /* Thumb styles */\n  /* The HTML slider thumb needs to be the same size as CustomThumb */\n  &::-webkit-slider-thumb {\n    -webkit-appearance: none;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    height: 3rem;\n    width: 4.8rem;\n  }\n\n  ::-moz-range-thumb {\n    background-color: transparent;\n    border: 0;\n    cursor: pointer;\n    height: 3rem;\n    width: 4.8rem;\n  }\n\n  &::-ms-thumb {\n    background-color: transparent;\n    border: 0;\n    cursor: pointer;\n    height: 3rem;\n    width: 4.8rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-bottom: 18px;\n  max-width: 100%;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * Styling for this component is based on these resources:
 * https://codepen.io/smhigley/pen/ObWbdy
 * https://digitalapexgroup.com/value-bubbles-for-range-inputs/
 * https://brennaobrien.com/blog/2014/05/style-input-type-range-in-every-browser.html
 */
var sliderTrack = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, "homepoint", _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme, "caliber", _Constant.Color.CALIBER_GREEN), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.SEA), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.SEA), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.SEA), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme));
var focusStyles = (0, _styledTheming.default)('mode', (_theme2 = {
  caliber: "outline: 3px solid ".concat(_Constant.Color.CALIBER_PASTEL_BLUE, ";")
}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, "outline 3px solid ".concat(_Constant.Color.HOMEBRIDGE_YELLOW_LIGHT, ";")), (0, _defineProperty2.default)(_theme2, "homepoint", "outline: 3px solid ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, "outline: 3px solid ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK, ";")), (0, _defineProperty2.default)(_theme2, "figure", "outline: 3px solid ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme2, "pella", "outline: 3px solid ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme2, "petersendean", "outline: 3px solid ".concat(_Constant.Color.FOCUS_B, ";")), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, "outline: 3px solid ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY, ";")), _theme2));

var SliderWrapper = _styledComponents.default.div(_templateObject());

var NativeSlider = _styledComponents.default.input(_templateObject2(), focusStyles);

var CustomTrack = _styledComponents.default.div(_templateObject3(), _Constant.Color.GREY_4);

var CustomFill = _styledComponents.default.span(_templateObject4(), function (props) {
  return props.trackColor !== '' ? props.trackColor : sliderTrack;
}, function (props) {
  return props.progress;
});

var CustomThumb = _styledComponents.default.img(_templateObject5(), function (props) {
  return props.progress;
}, function (props) {
  return props.progress * 0.5;
});
/**
 * TODO: The Limit component text is running into each other on iPhone5 sizes in HELOC.
 * Once HELOC is updated to use less padding on mobile sizes, lines 159 - 161 can be removed.
 */


var MinMaxContainer = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject6());

var Limit = _styledComponents.default.p(_templateObject7(), _Constant.Color.BLACK_SOUL);

var Slider = function Slider(_ref) {
  var disabled = _ref.disabled,
      id = _ref.id,
      isHiddenLabel = _ref.isHiddenLabel,
      min = _ref.min,
      max = _ref.max,
      onChange = _ref.onChange,
      sliderLabel = _ref.sliderLabel,
      step = _ref.step,
      trackColor = _ref.trackColor,
      value = _ref.value,
      otherProps = (0, _objectWithoutProperties2.default)(_ref, ["disabled", "id", "isHiddenLabel", "min", "max", "onChange", "sliderLabel", "step", "trackColor", "value"]);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      progress = _useState2[0],
      setProgress = _useState2[1];

  var formattedMin = min >= 0 ? "".concat((0, _numericFormatters.formatMoney)(min), " min") : '';
  var formattedMax = max >= 0 ? "".concat((0, _numericFormatters.formatMoney)(max), " max") : '';
  (0, _react.useLayoutEffect)(function () {
    if (value <= min) {
      setProgress(0);
      return;
    }

    if (value >= max) {
      setProgress(100);
      return;
    }

    var newProgress = (value - min) / (max - min) * 100;
    setProgress(newProgress);
  }, [value, min, max]);

  var handleChange = function handleChange(e) {
    return onChange((0, _util.parseNumericValue)(e.target.value));
  };

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    disabled: disabled,
    id: id,
    min: min,
    max: max,
    progress: progress,
    step: step,
    onChange: handleChange,
    type: 'range',
    value: value
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(SliderWrapper, {
    className: "slider-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: id,
    isVisuallyHidden: isHiddenLabel
  }, sliderLabel), /*#__PURE__*/_react.default.createElement(NativeSlider, inputProps), /*#__PURE__*/_react.default.createElement(CustomTrack, {
    "aria-hidden": "true",
    className: "custom-track"
  }, /*#__PURE__*/_react.default.createElement(CustomFill, {
    progress: progress,
    trackColor: trackColor
  }), /*#__PURE__*/_react.default.createElement(CustomThumb, {
    className: "custom-thumb",
    src: _thumb.default,
    progress: progress,
    alt: ""
  }))), /*#__PURE__*/_react.default.createElement(MinMaxContainer, {
    as: "div"
  }, /*#__PURE__*/_react.default.createElement(Limit, {
    "data-testid": "slider-min"
  }, formattedMin), /*#__PURE__*/_react.default.createElement(Limit, {
    "data-testid": "slider-max"
  }, formattedMax)));
};

Slider.propTypes = {
  /** If true, handles can't be moved. */
  disabled: _propTypes.default.bool,

  /** id for the range input */
  id: _propTypes.default.string,

  /** Visually hides the label text */
  isHiddenLabel: _propTypes.default.bool,

  /** The maximum value of the slider */
  max: _propTypes.default.number,

  /** The minimum value of the slider */
  min: _propTypes.default.number,

  /** onChange will be triggered while the value of Slider changing. */
  onChange: _propTypes.default.func.isRequired,

  /** Label text for range input. Can be visible or visually hidden. */
  sliderLabel: _propTypes.default.string,

  /** Value to be added or subtracted on each step the slider makes. Must be greater than zero, and max - min should be evenly divisible by the step value. */
  step: _propTypes.default.number,

  /** Custom slider track color */
  trackColor: _propTypes.default.string,

  /** Value that controls the slider  */
  value: _propTypes.default.number
};
Slider.defaultProps = {
  disabled: false,
  id: 'slider',
  isHiddenLabel: true,
  max: null,
  min: null,
  sliderLabel: 'Select an amount',
  step: 1,
  trackColor: '',
  value: 0
};
var _default = Slider;
exports.default = _default;